import { DashboardPickupRequestListSearch } from "../../../../types/operations/pickupRequestDashboardInterface";
import api from "../../../../lib/api";


export const getDashboardPickupRequestListApi = async (filterData: DashboardPickupRequestListSearch) => {
  return await api.post(`operations/pickup-request/dashboard`, filterData.data);
};